module.exports = __webpack_public_path__ + "img/Schnuppertag.ca10e429.png";